import { NgFor, NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { HeaderComponent } from '@shared/layout/header/header.component';
import { AppDatePipe } from '@shared/pipes/date.pipe';

type FieldMap = Record<string, string | number | boolean>;

@Component({
    selector: 'app-reports-view-page',
    imports: [
        ComponentsModule,
        HeaderComponent,
        NgFor,
        AppDatePipe,
        NgIf
    ],
    templateUrl: './reports-view-page.component.html',
    standalone: true,
    styleUrl: './reports-view-page.component.scss'
})
export class ReportsViewPageComponent implements OnInit {
    private http = inject(HttpClient);
    private readonly _router = inject(Router);
    path = '';
    mainHeading = this._router.url.split('?')[0].split('/')[2].replaceAll('-', ' ');
    startDate: string | null = null;
    endDate: string | null = null;

    tableData: FieldMap[] = [];
    tableHeaders: string[] = [];

    constructor(private router: Router) {
        this.path = this.router.url.split('/')[2];
        this.fetchReport();
    }

    ngOnInit() {
        const urlTree = this.router.parseUrl(this.router.url);
        this.startDate = urlTree.queryParams['start_date'] || null;
        this.endDate = urlTree.queryParams['end_date'] || null;
      }

    fetchReport() {
        const url = `api/${this.path}`;

        this.http.get<FieldMap[]>(url).subscribe({
            next: (data) => {
                this.tableData = data;
                if (data.length > 0) {
                    this.tableHeaders = Object.keys(data[0]);
                }
            },
            error: (err) => {
                console.error('Error fetching report:', err);
            }
        });
    }

    downloadReport() {
        const [basePath, queryString] = this.path.split('?');

        const url = `api/${basePath}-csv${queryString ? '?' + queryString : ''}`;

        this.http.get(url, { responseType: 'blob' }).subscribe({
            next: (blob) => {
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = `${this.path}.csv`;
                a.click();
                URL.revokeObjectURL(objectUrl);
            },
            error: (err) => {
                console.error('Download failed:', err);
            }
        });
    }

    formatHeader(header: string): string {
        return header.replace(/_/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());
    }

    refreshReport() {
        window.location.reload();
    }
}
